export default __webpack_public_path__ + "static/media/icon-file.ed33c50d.svg";